import React, { useState, useEffect, useRef } from 'react';
import styles from './SplashScreen.module.css';

export default function SplashScreen() {
  const [fading, setFading] = useState(false);
  const [hidden, setHidden] = useState(() => {
    if (typeof window === 'undefined') return true;
    // Don't block Lighthouse, PageSpeed, or headless audit bots
    const isBot = /Lighthouse|Chrome-Lighthouse|HeadlessChrome|PageSpeed|insights|Googlebot/i.test(
      navigator.userAgent
    );
    if (isBot) return true;
    try {
      if (sessionStorage.getItem('ffc_splash_seen')) return true;
    } catch (e) {}
    return false;
  });

  const dismissed = useRef(false);

  useEffect(() => {
    if (hidden) return;

    try {
      sessionStorage.setItem('ffc_splash_seen', 'true');
    } catch (e) {}

    const triggerFadeOut = () => {
      if (dismissed.current) return;
      dismissed.current = true;
      setFading(true);
      setTimeout(() => {
        setHidden(true);
      }, 300);
    };

    // Snappy, non-blocking 180ms brand introduction
    const timer = setTimeout(triggerFadeOut, 180);

    const onMotionReady = () => {
      triggerFadeOut();
    };

    window.addEventListener('church:motion-ready', onMotionReady, { once: true });

    return () => {
      clearTimeout(timer);
      window.removeEventListener('church:motion-ready', onMotionReady);
    };
  }, [hidden]);

  if (hidden) return null;

  return (
    <div className={`${styles.splashOverlay} ${fading ? styles.fadeOut : ''}`}>
      <div className={styles.splashContent}>
        <img
          src="/assets/logos/logofull.webp"
          alt="Faith Fellowship Church"
          className={styles.logo}
          width="260"
          height="80"
          decoding="async"
        />
      </div>
    </div>
  );
}
